export default "__VITE_ASSET__CuZNhpnd__"